<template>
  <section>
    <div>
      <CModal :show="cookies" color="danger" fullHeight position="center">
        <div slot="header">
          <!-- <mdb-icon icon="exclamation-circle" class="icono-error m-2" /> -->
          <h3>Error</h3>
        </div>
        <div class="center">
          {{ message }}
        </div>
        <div slot="footer">
          <mdb-btn color="danger" @click="closeModel()">Ok</mdb-btn>
        </div>
      </CModal>
      <!-- <CModal title="Error" color="danger" @ok="closeModel" @click="closeModel()" :show.sync="cookies" >
        {{message}}
    </CModal> -->
    </div>
    <CDropdown
      inNav
      class="c-header-nav-items"
      placement="bottom-end"
      add-menu-classes="pt-0"
    >
      <template #toggler>
        <CHeaderNavLink>
          <div class="c-avatar">
            <img src="img/logo_brand.png" class="c-avatar-img" />
          </div>
        </CHeaderNavLink>
      </template>
      <CDropdownHeader tag="div" class="text-center" color="light">
        <strong>Settings</strong>
      </CDropdownHeader>
      <CDropdownItem>
        <CIcon name="cil-user" />
        {{ userrootstate.username ? userrootstate.username : "A" }}
      </CDropdownItem>
      <CDropdownDivider />
      <CDropdownItem @click="handleLogout">
        <CIcon name="cil-lock-locked" /> Logout
      </CDropdownItem>
    </CDropdown>

    <CModal title="Perfill" :show.sync="perfillModal" size="sm" class="c-modal">
      <semipolar-spinner
        :animation-duration="2000"
        :size="50"
        color="blue"
        v-if="perfillModalShowSpinner"
      ></semipolar-spinner>
      <template
        #body-wrapper
        v-if="!perfillModalShowSpinner"
        style="max-height: 300px"
      >
        <div class="modal-body-wrapper">
          <label>Username:</label>
          <input
            type="text"
            class="form-control"
            disabled
            :value="userrootstate.username ? userrootstate.username : ''"
          />
        </div>
      </template>
      <template #footer v-if="!perfillModalShowSpinner">
        <CButton @click="perfillModal = false" color="danger">Close</CButton>
      </template>
    </CModal>
  </section>
</template>

<!--<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      itemsCount: 42
    }
  }
}
</script>-->

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import store from "../store";
import { SemipolarSpinner } from "epic-spinners";
import { mapGetters, mapState } from "vuex";
import {
  //   mdbContainer,
  // mdbModal,
  // mdbModalBody,
  // mdbModalHeader,
  // mdbModalFooter,
  // mdbRow,
  mdbBtn,
  mdbIcon,
  // mdbIcon,
  // mdbTextarea,
  // mdbInput
} from "mdbvue";
export default {
  name: "TheHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown,
    // mdbContainer,
    // mdbModal,
    // mdbModalBody,
    // mdbModalHeader,
    // mdbModalFooter,
    // mdbRow,
    mdbIcon,
    mdbBtn,
    SemipolarSpinner,
    // mdbIcon,
    // mdbTextarea,
    // mdbInput
  },
  data: () => {
    return {
      itemsCount: 42,
      user: {},
      modal: false,
      cookies: false,
      message: "",
      perfillModal: false,
      perfillModalShowSpinner: false,
      authStateStore: {},
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    handleLogout() {
      console.log("logout function");
      store.dispatch("logout").then(() => {
        this.$router.push("/login");
        localStorage.clear();
      });
    },
    closeModel() {
      console.log("logout need to invoke");
      this.cookies = false;
      // this.handleLogout();
      store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
    getUser() {
      this.user = 'PARA CAMBIAR'
    },
  },

  computed: mapState({
    userrootstate: "user",
  }),
};
</script>


<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
.modal-body {
}
</style>